const endpoints = 'AdminEndpoints';

export const SEND_POST_REQUEST = `${endpoints}/SEND_POST_REQUEST`;
export const SEND_POST_RESPONSE = `${endpoints}/SEND_POST_RESPONSE`;
